// Module
var code = "<div class=\"sentiments-bar\" ng-mouseenter=\"sentimentsTooltip(row, $event)\">\n    <div class=\"separator\"></div><div class=\"sentiments {{row.net_sent > 0 ? 'positive' : row.net_sent < 0 ? 'negative' : '';}}\" \n        style=\"width: {{Math.min(100, Math.pow(row.net_sent, 2))/2}}%;\"></div>\n</div>";
// Exports
module.exports = code;